import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Assessment = ({ showAssessment, handleCloseAssessment, assessment }) => {
  //const data = require("./sample-success.json")
  const data = assessment;
  //const data = null;
  const NBest = data? data.NBest[0]: null
  const summary = NBest?.PronunciationAssessment
  const words = NBest?.Words
  const Summary = (props) => {
    if (!props.data) return
    const { AccuracyScore, FluencyScore, CompletenessScore, PronScore, ProsodyScore } = props.data
    return (
      <>
        <h5>DisplayText</h5>
        <p>{data?.DisplayText}</p>
        <br />
        <h5>Summary</h5>
        <table className="table table-bordered" style={{ whiteSpace:"nowrap", minWidth:'1%', maxWidth:'1%' }}>
          <thead style={{ textAlign: 'center' }}>
            <tr>
              <th>Accuracy Score</th>
              <th>Fluency Score</th>
              <th>Completeness Score</th>
              <th>Pron Score</th>
              <th>Prosody Score</th>
              <th>Duration</th>
              <th>Confidence</th>
              <th>Recognition Status</th>
              <th>SNR</th>
            </tr>
          </thead>
          <tbody style={{ textAlign: 'center' }}>
            <tr>
              <td>{AccuracyScore}</td>
              <td>{FluencyScore}</td>
              <td>{CompletenessScore}</td>
              <td>{PronScore}</td>
              <td>{ProsodyScore}</td>
              <td>{data?.Duration/1000}</td>
              <td>{Math.round((NBest?.Confidence + Number.EPSILON) * 100) / 100}</td>
              <td>{data?.RecognitionStatus}</td>
              <td>{Math.round((data?.SNR + Number.EPSILON) * 100) / 100}</td>
            </tr>
          </tbody>
        </table></>
    )
  }

  const WordsAssessment = (props) => {
    //console.log(props.data)
    const words = props.data

    const Prosody = (props) => {
      const data = {
        Break: {
          ErrorTypes: ["None"],
          UnexpectedBreak: { Confidence: 3.3264033e-8 },
          MissingBreak: { Confidence: 1 },
          BreakLength: 0,
        },
        Intonation: {
          ErrorTypes: [],
          Monotone: { SyllablePitchDeltaConfidence: 0.521876 },
        },
      };
      
      const info = props.Prosody
      return (
        <table
          className="table table-bordered"
          style={{ border: "1px solid black", whiteSpace:"nowrap", minWidth:'1%', maxWidth:'1%' }}
        >
          <thead>
            <tr>
              <th style={{  whiteSpace:"nowrap", minWidth:'1%', maxWidth:'1%'}}>
                Assessment
                
              </th>
              <th style={{  whiteSpace:"nowrap", minWidth:'1%', maxWidth:'1%'}}>Confidence</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td  style={{  whiteSpace:"nowrap", minWidth:'1%', maxWidth:'1%', textAlign:'left', paddingLeft:'1em'}}>Unexpected Break</td>
              <td>
                {info?.Break?.UnexpectedBreak?.Confidence &&
                  info?.Break?.UnexpectedBreak?.Confidence.toExponential(2)}
              </td>
            </tr>
            <tr>
              <td style={{  whiteSpace:"nowrap", minWidth:'1%', maxWidth:'1%', textAlign:'left', paddingLeft:'1em'}}>Missing Break</td>
              <td>
                {info?.Break?.MissingBreak?.Confidence &&
                  Math.round(
                    (info?.Break?.MissingBreak?.Confidence + Number.EPSILON) *
                      100
                  ) / 100}
              </td>
            </tr>
            <tr>
              <td style={{  whiteSpace:"nowrap", minWidth:'1%', maxWidth:'1%', textAlign:'left', paddingLeft:'1em'}}>
                Intonation <br />
                <span style={{ fontSize: "0.75em" }}>
                  Syllable Pitch Delta Confidence
                </span>
              </td>
              <td style={{verticalAlign: 'middle'}}>
                {info?.Intonation?.Monotone?.SyllablePitchDeltaConfidence &&
                  Math.round(
                    (info?.Intonation?.Monotone?.SyllablePitchDeltaConfidence +
                      Number.EPSILON) *
                      100
                  ) / 100}
              </td>
            </tr>
          </tbody>
        </table>
      );
    };

    return (
      <>
        <br />
        <h5>Words Assessment</h5>
        <table className="table table-bordered"  style={{ whiteSpace:"nowrap", minWidth:'1%', maxWidth:'1%' }}>
          <thead style={{ textAlign: 'center' }}>
            <tr>
              <th>Word</th>
              <th>Overall</th>
              <th>ErrorType</th>
              <th>Prosody</th>
              <th>Syllables</th>
              <th>Phonemes</th>
            </tr>
          </thead>
          <tbody>
            {
              words.map((w) => {
                return (
                  <tr>
                    <td style={{ paddingLeft: '1.5em', verticalAlign: 'middle' }}>{w?.Word}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      {w?.PronunciationAssessment?.AccuracyScore}
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      {w?.PronunciationAssessment?.ErrorType}
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <Prosody Prosody={w?.PronunciationAssessment?.Feedback?.Prosody} />
                    </td>
                    <td style={{ width: '0%', textAlign: 'center', verticalAlign: 'middle' }}>
                      <table className="table table-bordered" style={{ border: '1px solid black' }}>
                        <thead>
                          <tr>
                            <th>Syllable</th>
                            <th>Grapheme</th>
                            <th>Score</th>
                            <th>Duration</th>
                            <th>Offset</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            w?.Syllables && w?.Syllables.map((s) => {
                              return <tr>
                                <td style={{ textAlign: 'left', paddingLeft: '1.2em' }}>
                                  {s?.Syllable}
                                </td>                                <td style={{ textAlign: 'left', paddingLeft: '1.2em' }}>
                                  {s?.Grapheme}
                                </td>
                                <td>
                                  {s?.PronunciationAssessment?.AccuracyScore}
                                </td>
                                <td>
                                  {s?.Duration/1000}
                                </td>
                                <td>
                                  {s?.Offset/1000}
                                </td>
                              </tr>
                            })

                          }
                        </tbody>
                      </table>
                    </td>
                    <td style={{ width: '0%', textAlign: 'center' }}>
                      <table className="table table-bordered" style={{ border: '1px solid black' }}>
                        <thead>
                          <tr>
                            <th>Phoneme</th>
                            <th>Score</th>
                            <th>Duration</th>
                            <th>Offset</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            w?.Phonemes && w?.Phonemes.map((s) => {
                              return <tr>
                                <td style={{ textAlign: 'left', paddingLeft: '1.2em' }}>
                                  {s?.Phoneme}
                                </td>
                                <td>
                                  {s?.PronunciationAssessment?.AccuracyScore}
                                </td>
                                <td>
                                  {s?.Duration/1000}
                                </td>
                                <td>
                                  {s?.Offset/1000}
                                </td>
                              </tr>
                            })
                          }
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table></>
    )
  }
  return (
    <Modal show={showAssessment} onHide={handleCloseAssessment} 
    size='sm'
    fullscreen={data?true:false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Assessment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          assessment ? <><Summary data={summary} />
            <WordsAssessment data={words} /></> : 'Assessment Unavailable'
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseAssessment}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
Assessment.propTypes = {};

Assessment.defaultProps = {};

export default Assessment;
